const localStorageNames = {
  unpauseData: 'unpauseData',
  smartSearchFilter: {
    male: 'smartSearchFilterMale',
    female: 'smartSearchFilterFemale',
  },

  authLogoRedirectUrl: 'authLogoRedirectUrl',

  // postponed
  netflixRecommendations: 'netflixRecommendations',
  queueProduct: 'postponedQueueProduct',
  queueProducts: 'postponedQueueProducts',
  queueLimitedProduct: 'postponedQueueLimitedProduct',
  queueLimitedProducts: 'postponedQueueLimitedProducts',
  cartProduct: 'postponedCartProduct',
  skincareIntroItems: 'skincareIntroItems',
  makeupLandingItems: 'makeupLandingItems',
  makeupLandingNewStyleItems: 'makeupLandingNewStyleItems',
  collectionLandingPageItems: 'customCollectionsPageItems',
  pickedProducts: 'pickedProducts',
  stockNotificationSubscriptionProductId: 'stockNotificationSubscriptionPostponedProductId',
}


export default localStorageNames
